import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=26f280f4&"
import script from "./GroupMenu.vue?vue&type=script&lang=ts&"
export * from "./GroupMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports